import { Inject, Pipe, PipeTransform } from 'ng-metadata/core';
import * as momentTz from 'moment-timezone';


/**
 * @ngdoc filter
 * @name mwTimestamp
 * @module mw.components.dataFormatting
 *
 * @param {Date} [date] - The Date
 * @param {string} [timezone] - Timezone to be used for formatting. It understands UTC/GMT and the
 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
 *    If not specified, the timezone of the browser will be used.
 * @returns {string} a new localized string representation of the date/timestamp
 *
 * @description
 * `mw-timestamp` filter converts a `Date` object to a formatted and localized string.
 */
@Pipe({name: 'mwTimestamp'})
export class TimestampPipe implements PipeTransform {
    constructor(@Inject('$translate') private $translate, @Inject('mwLocaleService') private mwLocaleService) {}

    transform(date: Date, timezone: string = momentTz.tz.guess()) {
        let theLocale = this.mwLocaleService.getLocale().localeID;

        // If date === today || yesterday, show the context properly
        if (momentTz(date).tz(timezone).isSame(new Date(), 'month') && momentTz(date).tz(timezone).isSame(new Date(), 'day') && momentTz(date).tz(timezone).isSame(new Date() , 'year')) {
            return this.$translate.instant('mw-timestamp--today') + momentTz(date).tz(timezone).locale(theLocale).format(' • LT');
        } else if (momentTz(date).tz(timezone).isSameOrBefore(new Date(), 'month') && momentTz(date).tz(timezone).isSame(new Date().setDate(new Date().getDate() - 1), 'day') && momentTz(date).tz(timezone).isSame(new Date(), 'year')) {
            return this.$translate.instant('mw-timestamp--yesterday') + momentTz(date).tz(timezone).locale(theLocale).format(' • LT');
        }


        // If neither of the above, determine whether or not its same year.
        if (momentTz(date).tz(timezone).year() === new Date().getFullYear()) {
            return momentTz(date).tz(timezone).locale(theLocale).format('ll').replace(/\d{4}/g, '').replace(/,/g, '') + momentTz(date).tz(timezone).locale(theLocale).format(' • LT');
        } else {
            return momentTz(date).tz(timezone).locale(theLocale).format('ll') + momentTz(date).tz(timezone).locale(theLocale).format(' • LT');
        }
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/data-formatting/timestamp.pipe.ts